import { useEffect, useCallback, useState } from 'react';
import { useOnlineStatus } from './useOnlineStatus';
import { getQueueCount } from '../lib/offlineQueue';
import { ACTION_QUEUE_CHANGED_EVENT, processActionQueue } from '../lib/actionQueueProcessor';

export function useOfflineSync() {
  const isOnline = useOnlineStatus();
  const [pendingCount, setPendingCount] = useState(0);
  const [isSyncing, setIsSyncing] = useState(false);

  const refreshCount = useCallback(async () => {
    const count = await getQueueCount();
    setPendingCount(count);
  }, []);

  const syncAll = useCallback(async () => {
    if (!isOnline || isSyncing) return;
    setIsSyncing(true);
    try {
      await processActionQueue();
    } finally {
      await refreshCount();
      setIsSyncing(false);
    }
  }, [isOnline, isSyncing, refreshCount]);

  useEffect(() => {
    if (isOnline) {
      syncAll();
    }
  }, [isOnline]);

  useEffect(() => {
    refreshCount();
    const interval = setInterval(refreshCount, 5000);
    const onQueueChanged = () => refreshCount();
    window.addEventListener(ACTION_QUEUE_CHANGED_EVENT, onQueueChanged);
    return () => {
      clearInterval(interval);
      window.removeEventListener(ACTION_QUEUE_CHANGED_EVENT, onQueueChanged);
    };
  }, [refreshCount]);

  return { isOnline, pendingCount, isSyncing, syncAll, refreshCount };
}
